import React, { Component } from "react";
import { connect } from "react-redux";

class ProgressBarWrapper extends Component {
	render() {
		return (
			<div
				className={this.props.progress == 100 ? "progress-bar progress-bar-done" : "progress-bar"}
				style={{ width: `${this.props.progress}%` }}
			/>
		);
	}
}

const mapStateToProps = (state, props) => ({
	progress: state.searchStatus.progress || 0
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBarWrapper);
